// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fB1o","badges":"styles_badges__1BNnj"};